import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { Pagination,Input } from 'antd';
import {app} from "../../config"
import { dateConverter } from '../../utils/utcDateConversion';
import { EditTwoTone } from '@ant-design/icons';
import { getTokenfromUserObj } from '../../utils/getTokenfromObj';
import NoRecordFound from '../../components/common/NoRecordFound';
const Organizations = () => {
  const { t } = useTranslation(['common']);
  const {Search}=Input;
  window.document.title = 'Organizations';
  const navigate = useNavigate();
  const [editbtn, setEditBtn] = useState('none');
  const [current, setCurrent] = useState(1);
  const [search,setSearch]=useState('');
  const [organizations, setOrganizations] = useState([]);
  const [pagesCount, setPagesCount] = useState(0);
  const [renderList,setRenderList]=useState([]);
  const [tableShow,setTableShow]=useState(true);
  const [err,setErr]=useState('');
  let searchedOrg;
  let orgsResponse;
  const token=getTokenfromUserObj();
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user.userType === 'A') setEditBtn('block');
    const fetchOrgs=async()=>{
    const limit=1000;
    const offset=0;
    orgsResponse=await axios.post(`${app.URL}/org/fetchall`,{limit,offset},{headers:{auth:token}});
    console.log(orgsResponse);
    console.log(orgsResponse.data.data);
    let convertedObj=orgsResponse.data?dateConverter(orgsResponse.data.data,"createdOn"):[];
    console.log(convertedObj)
    console.log(convertedObj.length);
    orgsResponse.data?setOrganizations(convertedObj):" ";
    orgsResponse.data?setPagesCount(convertedObj.length):" ";
    orgsResponse.data?setRenderList(convertedObj.slice(0,50)):console.log("Not Set");
    }
    fetchOrgs();
  }, []);
  const handleSearch=async()=>{
    console.log("Handle Search");
    console.log(search);
    try{
     const result=search?await axios.get(`${app.URL}/org/search/${search}`,{headers:{auth:token}}):[];
     console.log(result);
      searchedOrg=result.data.data;
    }
    catch(e){
      console.log("Error");
    if(e.message)setErr(e.response.data.message);
    setTableShow(false);
    }
    
    console.log(searchedOrg)
    if(searchedOrg){
      // setSearchShow(true);
      setRenderList(searchedOrg)
    }
    console.log(searchedOrg);
  }
  const onSearch = async (value) => {
    console.log(value);
    try{
      const result=await axios.get(`${app.URL}/org/search/${value}`,{headers:{auth:token}});
      console.log(result);
       searchedOrg=result.data.data;
       setRenderList(searchedOrg);
       setPagesCount(searchedOrg.length);
       
     }
     catch(e){
       console.log("Error");
     if(e.message)setErr(e.response.data.message);
     setTableShow(false);
     }
  }
  const handleSearchChange=(e)=>{
    console.log(e.target.value);
   if(!e.target.value){
    setRenderList(organizations.slice(0,50));
    console.log(organizations.length)
    setPagesCount(organizations.length);
    setTableShow(true);};
   setSearch(e.target.value)
  }
const onChange = async(page,pageSize) => {
  console.log(page,pageSize);
  setCurrent(page);
  if(!page)page=1;
  let limit=pageSize;
  let reqObj={
    limit,
    offset:limit*(page-1)
  }
  setRenderList(organizations.slice(reqObj.offset, reqObj.offset + limit));

  // console.log(reqObj);
  // const orgResp=await axios.post(`${app.URL}/org/fetchall`,reqObj);
  // console.log(orgResp.data.data);
  // if(orgResp.data){
  //   let convertedObj=dateConverter(orgResp.data.data,"createdOn");
  //   setRenderList(convertedObj)
  // }
};
console.log(organizations);


  const editOrg = (e) => {
    localStorage.setItem('orgId', JSON.stringify(e.organizationId));
    navigate('/organization/editorg', { replace: true });
  };
  const addOrganization=(e)=>{
    console.log(e);
    navigate('/organization/add',{replace:true});
}
  return (
    // <div className='w-100'>
    //      <Navbar/>
    //   <div className='row'>
    //   <div className='row'>
    //     </div>  
    //     <div className='row'>
    //     <div className='col-lg-3 col-md-3 col-sm-3'>
    //     <NewSideBar/>
    //     </div>
        <div className='ml-3 col-lg-12 col-md-12 col-sm-12 '>
         <div className='row mt-4'>
          <div className="col-lg-10 col-md-10 col-sm-10 fs-3 fw-bold">
          {t('Organization Management')}
          </div>
          </div>
          <div className='row text-center'>
          <div className="col-lg-8 offset-lg-1 mt-4">
          <Search
          className="search"
            placeholder='Search by Name / Email'
            onChange={handleSearchChange}
            onSearch={onSearch}
            style={{
              width: 300,
            }}
          />
          </div>
          <div className="col-lg-2 col-md-2 col-sm-2 mt-4">
          <button class="btn btn-primary button" onClick={addOrganization}>Add</button>  
          </div>  
          </div>
         
        <div className='col-lg-11 col-md-12 col-sm-12 '>
        <div class=' styled-table '>
           <table class='table text-black' >
             <thead class='thead-light'>
               <tr>
                 {/* <th >{t('ID')}</th> */}
                 <th >{t('Org Name')}</th>
                 <th>{t('Description')}</th>
                 <th>{t('Email')}</th>
                 <th>{t('Phone')}</th>
                 <th>{t('Address')}</th>
                 <th>{t('Type')}</th>
                 <th>{t('Status')}</th>
                 <th></th>
               </tr>
             </thead>
             <tbody >

               {renderList
                 ? renderList.map((output) => (
                     <tr className='row-hover'  onClick={()=>{editOrg(output)}}  >
                       {/* <td >{output.organizationId}</td> */}
                       <td style={{width:"180px"}}> {output.organizationName}</td>
                       <td style={{width:"160px"}}>{output.outletName}</td>
                       <td style={{width:"160px"}}>{output.email}</td>
                     <td style={{width:"160px"}}>{output.phone}</td>
                       <td style={{width:"220px"}}>{output.address}</td>
                       {/* className={output.status=="Active"?'green-back':'red-back'} */}
                       <td style={{width:"70px"}}>{output.organizationType===1?"Masjid":output.organizationType===2?"church":output.organizationType}</td>
                       <td style={{width:"40px"}} className={output.isActive?'green-back':'red-back'}>{output.isActive=='1'?"Active":"Inactive"}</td>
                       <td style={{width:"40px"}}>
                       <EditTwoTone displayName="edit" twoToneColor="blue" style={{fontSize:"20px"}} />
                         {/* <button type='button' style={{ display: editbtn }} class='btn btn-primary color1 button' onClick={() => editOrg(output)}>
                           {t('Edit')}
                         </button> */}
                       </td>
                     </tr>
                   ))
                 : ' '}
             </tbody>
           </table>
           
           {renderList&&renderList.length == 0?<NoRecordFound/>:" "}
         </div>
        </div>
        <Pagination style={{marginTop:"10px"}} onChange={onChange} defaultCurrent={current} pageSize={50} total={pagesCount} />
        </div>
    //     </div>  
    //   </div>
    // </div>
  );
};

export default Organizations;
